var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "wizard" } }, [
    _c(
      "div",
      { staticClass: "wizard-header" },
      [
        _c(
          "v-container",
          [
            _c(
              "v-overlay",
              {
                attrs: {
                  opacity: "0.40",
                  absolute: true,
                  value: _vm.isLoading,
                  "z-index": 3
                }
              },
              [
                _c("v-progress-circular", {
                  staticClass: "mr-10px",
                  attrs: {
                    indeterminate: "",
                    color: "primary",
                    size: 60,
                    width: 5
                  }
                }),
                _vm._v(" " + _vm._s(_vm.loadingMessage) + " ")
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }